import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

// no token required, this is public data
function getUserCerts(uid) {
  const url = '/api/user/' + uid + '/certs/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getUserClassTypes(uid, token) {
  const url = '/api/user/' + uid + '/class_types/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export { getUserCerts, getUserClassTypes };
